import React from 'react';
import { Modal as AntModal } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const Modal = styled(AntModal)`

.ant-modal-title {
    text-align: center;
    color: ${props => props.theme.primaryColor};
    text-transform: capitalize;
}

.ant-modal-body {
    padding: 8px 0;
    text-align: center;
    color: red;
}

.ant-modal-footer {
    text-align: center;

    .ant-btn {
        min-width: 76px;
    }

    .ant-btn-default {
        display: none !important;
    }
}
`;

const ErrorModal = ({
    open,
    message,
    onOk,
}) => {
    const { t } = useTranslation();

    return (
        <Modal
            centered
            destroyOnClose
            closable={false}
            width={320}
            open={open}
            onOk={onOk}
            title={t('common.notice')}
            okText={t('common.ok')}
        >
            {message}
        </Modal>
    );
}

export default ErrorModal;